// axios
import axios from "axios";
// helpers
import { clearToken, getToken } from "../helpers/auth";

const axiosMainInstance = axios.create({
  baseURL: "https://api.mtor.online",
});

export const dashboardLink = "https://admin.mtor.online";

// request interceptors
axiosMainInstance.interceptors.request.use(
  function (config) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("apiToken")}`;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// response interceptors
axiosMainInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401 && getToken()) {
      clearToken();
      window.location = "/login";
    }
    return Promise.reject(error);
  }
);
export default axiosMainInstance;
